import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import keys from 'lodash/keys';
import each from 'lodash/each';
import uniq from 'lodash/uniq';

/**
 * Returns a list of all the keys in an object or array.
 * @param {Object, Array} value
 */
const getKeys = value => {
    let found = [];

    if (isObject(value)) {
        found = keys(value);
        each(value, item => {
            found = found.concat(getKeys(item));
        });
    } else if (isArray(value)) {
        each(value, item => {
            found = found.concat(getKeys(item));
        });
    }

    return uniq(found);
};

export default getKeys;
